import { AfterViewInit, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CurrentUser } from '../../../providers/current-user';
import { LangsProvider } from '../../../providers/langs-provider';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { ConfigProvider } from "../../../../config-provider.service";
import { UtilsProvider } from "../../../providers/utils-provider.service";
import { AuthFormComponent } from "../auth-form/auth-form";

@Component({
  selector: 'auth-dialog',
  providers: [],
  styleUrls: ['./auth-dialog.scss'],
  standalone: true,
  imports: [
    MatDialogContent,
    AuthFormComponent
  ],
  templateUrl: './auth-dialog.html'
})
export class AuthDialogComponent implements AfterViewInit {
    public image: string = this.conf.assetsUrl + 'img/app-logo_black.png';
    public title = '';
    public nextUrl: string |null = null;
    public defaultNextUrl: string |null = null;
    public isRegistrationDisabled = false;

    constructor(
        public conf: ConfigProvider,
        public utils: UtilsProvider,
        public currentUser: CurrentUser,
        @Inject(MAT_DIALOG_DATA) private _data: any
    ) {
        if (_data.title) {
            this.title = _data.title;
        }
        if (_data.image) {
            this.image = _data.image;
        }
        if (_data.nextUrl) {
            this.nextUrl = _data.nextUrl;
        }
        if (_data.defaultNextUrl) {
            this.defaultNextUrl = _data.defaultNextUrl;
        }
        if (_data.isRegistrationDisabled) {
            this.isRegistrationDisabled = true;
        }
    }

    public ngAfterViewInit() {
    }
}
